import React from 'react';
import postal from 'postal';
import { StringConstantsMixin } from './mixins/shared/string_constants_mixin';

const createReactClass = require('create-react-class');

const TrailRatingStars = createReactClass({
  componentWillReceiveProps(props) {
    this.setState({ avgRating: props.avgRating });
  },
  componentWillMount() {
    if (postal) {
      const messagingChannelName = 'trail_show_messagingChannel';
      this.messagingChannel = postal.channel(messagingChannelName);
      this.listeners = [this.messagingChannel.subscribe('reviews.changed', this.handleReviewsChanged)];
    }
  },
  componentWillUnmount() {
    if (postal) {
      this.listeners.forEach(function(sub) {
        postal.unsubscribe(sub);
      });
    }
  },
  getInitialState() {
    return { avgRating: this.props.avgRating };
  },
  handleReviewsChanged(data) {
    if (this.props.shouldUpdate) {
      this.setState({ avgRating: data.avgRating });
    }
  },
  render() {
    if (!this.state.avgRating || this.state.avgRating <= 0 || this.state.avgRating > 5)
      return (
        <span
          className={`rating lazyload star_0 ${this.props.extraClasses}`}
          data-bg="https://cdn-assets.alltrails.com/assets/icons/stars/star0.png"
        />
      );

    const roundedRating = Math.round(this.state.avgRating * 2.0) / 2;
    const dataBg = `https://cdn-assets.alltrails.com/assets/icons/stars/star${roundedRating.toString().replace('.', '-')}.png`;
    let ratingClass = `rating lazyload star_${roundedRating.toString().replace('.', '-')}`;
    ratingClass += ` ${this.props.extraClasses}`;
    return <span className={`${ratingClass} ${StringConstantsMixin.constants.XLATE.NONE}`} data-bg={dataBg} title={this.state.avgRating} />;
  }
});

TrailRatingStars.defaultProps = {
  shouldUpdate: false
};

export { TrailRatingStars };
